<template>
    <div ref="mapContainer" class="map-container">
        <!-- 自定义放大缩小控件 -->
        <div class="map-control">
            <div @click="zoomIn" class="zoom-in"><em>&#xE094;</em></div>
            <div @click="zoomOut" class="zoom-out"><em>&#xE095;</em></div>
            <img  class="map-layer-smallimg" src="@/assets/map/map-layer-small.png"
                @click="changeLayerShow = !changeLayerShow">
        </div>
        <div v-if="changeLayerShow" class="layer-control">
            <div class="layer-satellite" @click="changeMapLayer('卫星图')">卫星图</div>
            <div class="layer-standard" @click="changeMapLayer('标准图')">标准图</div>
        </div>
    </div>
</template>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';

export default {
    name: 'MapComponent',
    props: {
        initialCenter: {
            type: Array,
            default: () => [116.3095, 39.891],
        },
        initialZoom: {
            type: Number,
            default: 18,
        },
    },
    data() {
        return {
            map: null, // 地图实例
            changeLayerShow: false,
            standartLayer: null,
            satelliteLayer: null,
            activeLayer: "标准图",
        };
    },
    mounted() {
        this.initMap();
        // let mapTypenow = sessionStorage.getItem('currentMapType');
        // if(mapTypenow){
        //     this.changeMapLayer(mapTypenow)
        // }
    },
    beforeUnmount() {
        // 清理地图实例以释放资源
        if (this.map) {
            this.map.setTarget(null); // 移除地图的目标容器
            this.map = null;
            if (this.$setGlobalMap) {
                this.$setGlobalMap(null);
            }
        }
    },
    methods: {
        async initMap() {
            let apiKey = '3aebe17233dc2b0ad3b5e07cc875711b';

            // 创建天地图矢量瓦片源
            this.standardLayer = new TileLayer({
                source: new XYZ({
                    renderMode: 'image',
                    minZoom: 1,
                    maxZoom: 18,
                    url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=${apiKey}`,
                    crossOrigin: "anonymous",
                    tileLoadFunction: function (imageTile, src) {
                        // 使用滤镜将白色修改为深色（#3D3D3D 风格）
                        let img = new Image();
                        img.setAttribute("crossOrigin", "anonymous"); // 设置跨域属性
                        img.onload = function () {
                            let canvas = document.createElement("canvas");
                            let w = img.width;
                            let h = img.height;
                            canvas.width = w;
                            canvas.height = h;
                            let context = canvas.getContext("2d");

                            // 绘制原始图片
                            context.drawImage(img, 0, 0, w, h);

                            // 应用滤镜效果
                            context.filter =
                                "grayscale(100%) invert(95%) brightness(40%) contrast(80%)"; // 调整为 #3D3D3D 风格

                            // 将滤镜应用到图片
                            context.drawImage(canvas, 0, 0, w, h);

                            // 将处理后的图片赋值给瓦片
                            imageTile.getImage().src = canvas.toDataURL("image/png");
                        };
                        img.src = src; // 加载原始图片
                    },
                }),
                visible: true,

            });

            this.satelliteLayer = new TileLayer({
                source: new XYZ({
                    renderMode: 'image',
                    minZoom: 1,
                    maxZoom: 18,
                    url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=${apiKey}`,
                }),
                visible: true,

            });

            // 标注图层
            // let annotationLayer = new TileLayer({
            //     source: new XYZ({
            //         url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=${apiKey}`,
            //         crossOrigin: "anonymous"
            //     }),
            //     visible: true
            // });

            // 初始化地图实例
            this.map = new Map({
                target: this.$refs.mapContainer,
                layers: [this.standardLayer,],
                view: new View({
                    projection: "EPSG:4326",
                    center: this.initialCenter, // 使用 fromLonLat 转换经纬度到 EPSG:3857
                    zoom: this.initialZoom,


                }),
                controls: [],
            });

            if (this.map && this.$setGlobalMap) {
                this.$setGlobalMap(this.map);
                console.log(123123, this.$map)
            }
            this.$emit('map-ready', this.map);

            console.log('🗺️ 地图已初始化完成');
        },

        /**
         * 放大地图
         */
        zoomIn() {
            let view = this.map.getView();
            let zoom = view.getZoom();
            view.setZoom(zoom + 1);
        },

        /**
         * 缩小地图
         */
        zoomOut() {
            let view = this.map.getView();
            let zoom = view.getZoom();
            view.setZoom(zoom - 1);
        },

        /**
         * 获取地图实例
         * @returns {Map|null} 返回地图实例
         */
        getInstance() {
            return this.map;
        },

        /**
         * 动态添加图层
         * @param {TileLayer|VectorLayer} layer - 要添加的图层
         */
        addLayer(layer) {
            if (this.map) {
                this.map.addLayer(layer);
            } else {
                console.warn('地图实例尚未初始化，无法添加图层');
            }
        },

        changeMapLayer(layer) {
            if (this.activeLayer == layer) {
                return;
            }
            // sessionStorage.setItem('currentMapType', layer)
            if (layer == "标准图") {
                this.map.addLayer(this.standardLayer);
                if (this.satelliteLayer) {
                    this.map.removeLayer(this.satelliteLayer);
                }
            } else if (layer == "卫星图") {
                this.map.addLayer(this.satelliteLayer)
                if (this.standardLayer) {
                    this.map.removeLayer(this.standardLayer);
                }
            }
            this.activeLayer = layer;
        }
    },
};
</script>

<style scoped>
.map-layer-smallimg{
    margin-top:10px;cursor: pointer;
    width: 36px;
    height: 36px;
}
.map-container {
    width: 100%;
    height: 100vh;
    position: relative;
    z-index: 100;
    /* 确保子元素可以相对定位 */
}

/* 放大缩小控件样式 */
.map-control {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1000;
    color: #8D8D92;
    font-size: 16px;

    .zoom-in {
        background-color: #17181D;
        text-align: center;
        line-height: 36px;
        border-bottom: 1px solid #232630;
        width: 36px;
        height: 36px;
        cursor: pointer;
        border-radius: 20px 20px 0 0;
    }

    .zoom-out {
        background-color: #17181D;
        text-align: center;
        line-height: 36px;
        width: 36px;
        height: 36px;
        cursor: pointer;
        border-radius: 0 0 20px 20px;
        border-top: 1px solid #232630;
    }
}

.layer-control {
    position: absolute;
    bottom: 20px;
    right: 70px;
    display: flex;
    flex-direction: row;
    z-index: 1000;
    color: #8D8D92;
    font-size: 12px;
    font-weight: bold;

    .layer-satellite {
        border: 4px solid #17181D;
        height: 50px;
        width: 100px;
        background-image: url('@/assets/map/layer-satellite.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        cursor: pointer;
    }

    .layer-standard {
        border: 4px solid #17181D;
        height: 50px;
        width: 100px;
        background-image: url('@/assets/map/layer-standard.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        cursor: pointer;

    }

    .layer-satellite:hover {
        border-color: #387ff7;
    }

    .layer-standard:hover {
        border-color: #387ff7;
    }
}
</style>